export var SecurityScanExclusionPathType;
(function (SecurityScanExclusionPathType) {
    SecurityScanExclusionPathType["SECURITY_SCAN_EXCLUSION_PATH_TYPE_PATH"] = "PATH";
    SecurityScanExclusionPathType["SECURITY_SCAN_EXCLUSION_PATH_TYPE_TABLE"] = "TABLE";
    SecurityScanExclusionPathType["SECURITY_SCAN_EXCLUSION_PATH_TYPE_DATABASE"] = "DATABASE";
})(SecurityScanExclusionPathType || (SecurityScanExclusionPathType = {}));
